import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import splitStringUsingRegex from "../utils/splitStringUsingRegex";
import "../css/Home.css";

const text =
  "Welcome to Gloucester Road Pharmacy, your neighbourhood pharmacy situated on Gloucester Road in Bristol known for its independent shops.";

const charVariants = {
  hidden: { opacity: 0 },
  reveal: { opacity: 1 },
};

const Home = () => {
  const textChars = splitStringUsingRegex(text);

  return (
    <div className="home">
      {/* Vaccination Banner */}
      <div className="vaccination-banner">
        <div className="vaccination-banner__content">
          <div className="vaccination-banner__text-container">
            <img
              src="./nhs_logo.png"
              alt="NHS Logo"
              className="vaccination-banner__logo"
            />
            <p className="vaccination-banner__text">
              We are offering NHS FLU and COVID-19 vaccinations from the 1st
              October 2026, please book an appointment{" "}
              <a
                href="https://www.nhs.uk/nhs-services/vaccination-and-booking-services/book-flu-vaccination/"
                target="_blank"
                rel="noopener noreferrer"
                className="vaccination-banner__link"
              >
                here
              </a>
              . In the link above, please book for a COVID vaccination alongside
              if you are eligible.
              <br />
              <br />
              We are offering NHS Men B vaccination, please book an appointment{" "}
              <a
                href="https://www.nhs.uk/nhs-services/vaccination-and-booking-services/book-a-menb-vaccination-appointment/"
                target="_blank"
                rel="noopener noreferrer"
                className="vaccination-banner__link"
              >
              here
              </a>
              <p>if you are eligible.</p>
              <br />
              UPDATE: We are offering{" "}
              <u>
                Walk In FLU vaccination services from the 19th October 2026
                onwards
              </u>{" "}
              on a first come first serve basis, please visit us in person or call us for more information.
            </p>
          </div>
        </div>
      </div>

      <div className="private-banner">
        <p className="private-banner__text">
          <strong>NEW:</strong> We have started offering Private COVID-19 and
          Men B vaccinations, please kindly call to enquire.
        </p>
      </div>

      {/* Christmas Opening Hours Banner */}
      {/* <div className="xmas-banner">
        <div className="xmas-banner__content">
          <p className="xmas-banner__text">
            <span className="xmas-banner__icons">❄️🔔</span>
            <span className="xmas-banner__message">
              For our opening hours during the Christmas period,&nbsp;
              <Link to="/contact#xmas-hours" className="xmas-banner__link">
                click here
              </Link>
              .
            </span>
            <span className="xmas-banner__icons xmas-banner__icons--end">🔔❄️</span>
          </p>
        </div>
      </div> */}

      <div className="home__content">
        <div className="home__image-container">
          <img
            src="/pharmacy.jpg"
            alt="Gloucester Road Pharmacy"
            className="home__image"
          />
        </div>
        <motion.p
          initial="hidden"
          whileInView="reveal"
          transition={{ staggerChildren: 0.02 }}
        >
          {textChars.map((char, index) => (
            <motion.span
              key={index}
              transition={{ duration: 0.5 }}
              variants={charVariants}
            >
              {char}
            </motion.span>
          ))}
        </motion.p>
      </div>
    </div>
  );
};

export default Home;
